"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionModule = void 0;
const tx_1 = require("../codec/Switcheo/carbon/position/tx");
const util_1 = require("../util");
const base_1 = __importDefault(require("./base"));
class PositionModule extends base_1.default {
    editMargin(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgSetMargin.fromPartial({
                creator: wallet.bech32Address,
                marketId: params.marketId,
                margin: params.margin.toString(10),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetMargin,
                value,
            }, opts);
        });
    }
    editMargins(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const msgs = params.map((param) => {
                const value = tx_1.MsgSetMargin.fromPartial({
                    creator: wallet.bech32Address,
                    marketId: param.marketId,
                    margin: param.margin.toString(10),
                });
                return {
                    typeUrl: util_1.CarbonTx.Types.MsgSetMargin,
                    value,
                };
            });
            return yield wallet.sendTxs(msgs, opts);
        });
    }
}
exports.PositionModule = PositionModule;
